module.exports = __webpack_public_path__ + "static/media/Fleur Delacour 1.2d55b410.jpg";